import createKeyFactory, { KEYS } from 'utils/createKeyFactory';

const seasonPassFactory = {
  ...createKeyFactory([KEYS.SEASON_PASS]),
  seasonPassUser: (id: string, uniqueId: string) => [...seasonPassFactory.details(id), 'user', uniqueId],
};

export default seasonPassFactory;
